import { render } from "./myRentals.vue?vue&type=template&id=5cb9c1c8"
import script from "./myRentals.vue?vue&type=script&lang=js"
export * from "./myRentals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__